// frontend/src/components/NotificationBell.js
import React, { useState } from 'react';
import { usePushNotifications } from '../hooks/usePushNotifications';

/**
 * Campana de notificaciones en el navbar.
 * Si el navegador soporta push, muestra un icono que al hacer clic
 * pide permiso para activar notificaciones.
 */
function NotificationBell() {
    const { isSupported, permission, isSubscribed, subscribe, unsubscribe } = usePushNotifications();
    const [loading, setLoading] = useState(false);
    const [feedback, setFeedback] = useState('');

    if (!isSupported) return null;

    const handleClick = async () => {
        setLoading(true);
        setFeedback('');

        if (isSubscribed) {
            await unsubscribe();
            setFeedback('Notificaciones desactivadas');
        } else {
            const result = await subscribe();
            if (result.success) {
                setFeedback('Notificaciones activadas!');
            } else if (result.reason === 'denied') {
                setFeedback('Permiso denegado en el navegador');
            } else {
                setFeedback('Error al activar');
            }
        }

        setLoading(false);
        // Limpiar el feedback despues de 3 segundos
        setTimeout(() => setFeedback(''), 3000);
    };

    const iconClass = isSubscribed ? 'bi-bell-fill text-warning' : 'bi-bell text-secondary';
    const title = isSubscribed ? 'Notificaciones activadas — clic para desactivar' : 'Activar notificaciones';

    return (
        <div className="position-relative d-inline-block me-2">
            <button
                className="btn btn-link p-0 nav-link"
                onClick={handleClick}
                disabled={loading}
                title={title}
                style={{ fontSize: '1.1rem', lineHeight: 1 }}
            >
                {loading
                    ? <span className="spinner-border spinner-border-sm" role="status" />
                    : <i className={`bi ${iconClass}`} />
                }
            </button>
            {feedback && (
                <div
                    className="position-absolute bg-dark text-white rounded px-2 py-1"
                    style={{
                        top: '120%', right: 0, whiteSpace: 'nowrap',
                        fontSize: '0.75rem', zIndex: 1000
                    }}
                >
                    {feedback}
                </div>
            )}
        </div>
    );
}

export default NotificationBell;
